import { render, staticRenderFns } from "./LeadBuyingInfo.vue?vue&type=template&id=c12226ea&scoped=true&"
import script from "./LeadBuyingInfo.vue?vue&type=script&lang=js&"
export * from "./LeadBuyingInfo.vue?vue&type=script&lang=js&"
import style0 from "./LeadBuyingInfo.vue?vue&type=style&index=0&id=c12226ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12226ea",
  null
  
)

export default component.exports